import React from 'react';

import './style.scss';

const PageSectionHeading = ({ children }) => {
	return <h2 className="page-section-heading">{children}</h2>;
};

export default PageSectionHeading;
